/* eslint-disable react/no-unescaped-entities */
import { Link } from "react-router-dom";
import Navbar from "../components/dmb/Navbar";
import Footer from "../components/dmb/Footer";
import Seo from "../components/dmb/Seo";

export default function PlaceholderPage({ title, kicker, note }) {
    return (
        <>
            <Seo
                title={`${title} | DMB Partners`}
                description={note || "Cette page est en cours de finalisation."}
                path="/404"
                robots="noindex, follow"
            />
            <Navbar />
            <main className="min-h-[60vh]">
                <section className="section-pad">
                    <div className="container-dmb max-w-3xl">
                        {kicker && (
                            <div className="surtitre mb-4">{kicker}</div>
                        )}
                        <h1 className="text-dmb-navy">{title}</h1>
                        <p className="mt-6 text-[17px] text-dmb-muted leading-[1.7]">
                            {note ||
                                "Cette page est en cours de finalisation dans le cadre de la refonte Neo. Son contenu sera livré au prochain jalon."}
                        </p>
                        <Link
                            to="/"
                            className="btn-dmb btn-outline-dark mt-10 !h-11 !px-5 text-[14px]"
                        >
                            ← Retour à l'accueil
                        </Link>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    );
}
